export enum DocumentType {
    ARTICLE = "ARTICLE",
    BLOCK = "BLOCK",
    PERSON = "PERSON",
}

export enum DocumentTypeEnum {
    ARTICLE = "1",
    BLOCK = "2",
    PERSON = "3",
}

export enum DocumentBlockType {
    BLOCK = "BLOCK",
    FORMAT = "FORMAT",
}

export enum DocumentIdAttr {
    ARTICLE = "is-article",
    BLOCK = "is-block",
    FORMAT_BLOCK = "is-format-block",
}

export type TDocumentIdAttr = DocumentIdAttr;
